import api from '../../api/moudles/chat'

// import {
// 	SET_GOODS_LIST,
// } from '../mutation-types'

const state = () => ({
    options : {
        title: {
            text: '用户故事'
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: ['预算分配', '实际开销']
        },
        radar: {
            // shape: 'circle',
            indicator: [
                { name: '销售',max: 6500},
                { name: '管理', max: 16000},
                { name: '信息技术',max: 30000},
                { name: '客服', max: 38000},
                { name: '研发', max: 52000},
                { name: '市场', max: 25000}            
            ],
            radius: 130,
            // center: ['50%', '60%'],
            name: {
                formatter: '【{value}】',
                textStyle: {
                    color: '#428BD4'
                }
            },
        },
        series: [{
            type: 'radar',
            tooltip: {
                trigger: 'item'
            },
            data: [
                {
                    value: [4200, 3000, 20000, 35000, 50000, 18000],
                    name: '预算分配',
                        symbol: 'rect',
                        symbolSize: 12,
                        lineStyle: {
                            type: 'dashed'
                        },
                },
                {
                    value: [5000, 14000, 28000, 26000, 42000, 21000],
                    name: '实际开销',
                }
            ]
        }]
    },

})

const getters = {}

const actions = {
    getUnreadCount({state},payload){
        api.unreadCount({
          userId:this.userId
        }).then(res=>{
            var that =this
            console.log(res.conversations)
            for(var key in res.conversations){
                for(var i in this.authorizedShopList){
                  if(res.conversations[key][0]!=undefined){
                      if(that.authorizedShopList[i].shopId==key){
                        this.authorizedShopList[i].unread = true
                      }
                  }else{
                      if(that.authorizedShopList[i].shopId==key){
                        this.authorizedShopList[i].unread = false
                      }
                  }
              }
                if(this.shopId!=null){
                  this.getConversationList(this.filters)
                  if(this.conversationData.unreadCount!=0){
                    this.getConversation(this.conversationHistoryParams)
                  }
                }
                this.unreadData[key] = res.conversations[key]
            }
        })
      },
  

    
    
}

const mutations = {
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
}
